import { useFormik } from 'formik'
import Input from 'MediaManager/components/Form/Input'
import {
  getRoomClassifications,
  upsertRoomClassificationPackageCategories,
} from 'MediaManager/services/roomClassifications'
import React, { useCallback, useMemo } from 'react'
import Button from 'shared/components/Button'
import Select from 'shared/components/Select'
import TinyModal from 'shared/components/TinyModal'
import { useRequest } from 'shared/hooks/useRequest'

function RoomItemModal({ onClose = () => {}, onSuccess = () => {}, pack, room, edit, category }) {
  const formik = useFormik({
    initialValues: {
      item: category || '',
    },
    validateOnBlur: true,
    // validationSchema,
    initialTouched: false,
    validateOnMount: true,
    onSubmit: async () => {
      const updatedCategories = [...room.categories]
      if (edit) {
        const index = await updatedCategories.findIndex((i) => i === category)
        updatedCategories[index] = formik.values.item
      } else {
        updatedCategories.push(formik.values.item)
      }
      try {
        await upsertRoomClassificationPackageCategories({
          room_classification_id: room.id,
          categories: updatedCategories.join(','),
          package_id: pack.id,
        })
      } catch (error) {
        console.log('Partial error while adding room item:', error)
      } finally {
        onSuccess()
      }
    },
  })

  const isValid = true

  return (
    <TinyModal title={edit ? 'Edit item to room' : 'Add Item to Room'} className="lg:!w-[500px]">
      <form className="w-full" onSubmit={formik.handleSubmit}>
        <Input
          name="item"
          value={formik.values.item}
          label="Item Name"
          placeholder="Enter Item name"
          onChange={formik.handleChange}
        />
        <div
          className={`flex justify-end items-center  w-full mt-[16px] ${
            formik.isSubmitting ? 'pointer-events-none  opacity-50' : ''
          }`}
        >
          <Button size="small" rounded variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button
            size="small"
            loading={formik.isSubmitting}
            disabled={!isValid}
            rounded
            className="ml-[16px]"
            type="submit"
          >
            {edit ? 'Edit' : 'Add'}
          </Button>
        </div>
      </form>
    </TinyModal>
  )
}

export default RoomItemModal
